import { FC, useState, useEffect } from "react";
import {
    MenuItem, FormGroup, Checkbox, Box, Button, DialogActions,
    DialogContent, DialogTitle, Grid, Typography, Tooltip, TextField
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

import { styled } from '@mui/material/styles';
import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';
import TagFacesIcon from '@mui/icons-material/TagFaces';
import { toast } from "react-toastify";
import CustomTextField from "../FormFields/CustomTextField";

interface EmailChipProps {
    buyerEmail: any;
    methods:  any;
    selectedEmailData: (data: any) => void;
    isEdit?: boolean;
}

interface ChipData {
    key: number;
    label: string;
}

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
}));


// Address component
const EmailChip: FC<EmailChipProps> = ({ buyerEmail, methods, selectedEmailData, isEdit }) => {

    const [toEmail, setToEmail] = useState("");
    const [chipData, setChipData] = useState<readonly ChipData[]>([]);
    

    const handleDeleteChip = (chipToDelete: ChipData) => () => {
        if(isEdit) {
            setChipData((chips) => chips.filter((chip) => chip.key !== chipToDelete.key));
        }
    };

    const handleKeyDown = (event: any) => {
        // event.preventDefault()
        if (["Enter", "Tab", ","].includes(event.key) || event.keyCode === 32) {
            var value = event.target.value.trim();
            if (value && cehckIsValid(value)) {
                setChipData([...chipData, { key: chipData.length, label: value }])
                methods.setValue("toEmail", '');

            }
            return true;
        }
    };

    const cehckIsValid = (emailString: any) => {
        let error = null;
        if (isInList(emailString)) {
            error = `${emailString} has already been added.`;
        } else if (!isEmailValid(emailString)) {
            error = `${emailString} is not a valid email address.`;
        }
        if (error) {
            toast.error(error)
            return false;
        }
        return true;
    }

    const isInList = (emailString: any) => {
        // let chips = chipData.map((chip) => chip.label);

        let chips = chipData.map(({ key, label }) => {
            return label;
        });
        return chips.includes(emailString);
    }

    const isEmailValid = (emailString: any) => {
        return /[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/.test(emailString);
    }

    useEffect(() => {
        let emailData: any = null;
        if (buyerEmail instanceof Array ) {
            console.log(" array of instance ");
            emailData = buyerEmail
        } else if ( typeof buyerEmail === 'string' || buyerEmail instanceof String ) {
            console.log(" array of string ");
            emailData = buyerEmail.split(',')
        }
        let chips: any = []
        if (emailData && emailData.length > 0 ) {
            for (let i=0; i<emailData.length; i++) {
                console.log(emailData[i]);
                chips.push({key: i, label: emailData[i]})
            }
            console.log(chips);
            setChipData(chips);
        } else {
            setChipData(chips);
        }
    }, [isEdit]);

    useEffect(() => {
        console.log("cehcking isEdit -----> ", isEdit);
        console.log("cehcking buyerEmail -----> ", buyerEmail);
        let mailerList = chipData.map(({ key, label }) => {
            return label;
        });
        selectedEmailData(mailerList)
    }, [chipData, isEdit]);
      

    return (
        <>
        
        
        
        {/* <Grid justifyContent="left" spacing={2} rowSpacing={-2}> */}
            {
            <>
            <Grid item xs={12}>
            {/* <Typography>{JSON.stringify(chipData)}</Typography> */}
            </Grid>
            <Grid item xs={12}>
            <h5 className='c-label'>Type or paste email addresses</h5>
                <TextField
                    placeholder='Type or paste email addresses and press `Enter or Sapce`...' 
                    className='c-text-field' 
                    {...methods.register('toEmail')}
                    disabled={(!isEdit) ? true : false}
                    variant="standard" 
                    sx={{width:'100%'}}
                    size='small'
                    InputProps={{
                      disableUnderline: true,
                    //   readOnly: (buyerEmail && isEdit)? false : true
                    }}
                onKeyDown={(e: any) => handleKeyDown(e)}
                // disabled={(!isEdit)? false : true}
                // InputProps={{ readOnly: (buyerEmail && isEdit)? true : false }}
                // ref={elmRef}
                // InputLabelProps={{ shrink: true }} 
            />
            </Grid>
            </>
            }
            {chipData.length > 0 && 
            <Grid item xs={12} mt={1}>
                <h5 className='c-label'>Mailing Addresses :</h5>
                {/* <Typography>{'Customer Emails: '}</Typography> */}
                <Paper
                    sx={{
                    display: 'flex',
                    justifyContent: 'left',
                    flexWrap: 'wrap',
                    listStyle: 'none',
                    p: 0,
                    m: 0,
                    border:'none',
                    boxShadow:'none',
                    backgroundColor: '#fff'
                    }}
                    component="ul">
                        {/* <Typography >{'Customer Emails: '}</Typography> */}
                    {/* <ListItem key="UniqueID">
                        <Typography>
                            Mailing Addresses : 
                            <Tooltip title="Use Below Input Text field to add the email addresses"><InfoIcon style={{ fontSize: '12px', color: '#09b2ee' }}></InfoIcon></Tooltip>
                        </Typography>
                    </ListItem> */}
                    {chipData.map((data) => {
                    let icon;

                    if (data.label === 'React') {
                        icon = <TagFacesIcon style={{color:'#488dff'}}/>;
                    }

                    return (
                        <>
                        
                        <ListItem key={data.key}>
                        <Chip
                            icon={icon}
                            label={data.label}
                            style={{color:'#488dff',borderColor:'#488dff'}}
                            variant="outlined"
                            color="error"
                            onDelete={isEdit ? handleDeleteChip(data) : undefined}
                        />
                        </ListItem>
                        </>
                    );
                    })}
                </Paper>
            </Grid>
            }
        {/* </Grid> */}

        </>
    )

}

export default EmailChip;
